import React from 'react'
import PropTypes from 'prop-types'
import Jsonld from '@/modern/components/Seo/Jsonld'
import { SELLER_TYPE_ENUM } from '@/utils/constants'
import { SCHEMA_CONTEXT } from '@/modern/components/Seo/schemas/constants'
import {
  getItemCondition,
  buildSchemaId,
} from '@/modern/components/Seo/schemas/helpers/schemaCommon.helper'

export default function ProductSchema({
  ad,
  address,
  canonical,
  productSchemaData,
}) {
  const { valid, price, image } = productSchemaData
  if (!valid) return null

  const { Specification: spec, Seller: seller } = ad
  const id = buildSchemaId(canonical)
  const itemCondition = getItemCondition(spec)
  const hasSeller =
    seller && seller.SellerType === SELLER_TYPE_ENUM.PJ && seller.FantasyName
  const schemaTypeId = 'jsonld_product_da'

  const json = {
    '@context': SCHEMA_CONTEXT,
    '@type': 'Product',
    '@id': id,
    name: spec.Title,
    url: canonical,
    ...(spec.Make?.Value && {
      brand: { '@type': 'Brand', name: spec.Make.Value },
    }),
    ...(ad.UniqueId !== undefined && {
      identifier: {
        '@type': 'PropertyValue',
        name: 'ID do anúncio',
        value: String(ad.UniqueId),
      },
    }),
    image,
    offers: {
      '@type': 'Offer',
      price,
      priceCurrency: 'BRL',
      availability: `${SCHEMA_CONTEXT}/InStock`,
      ...(itemCondition && {
        itemCondition: `${SCHEMA_CONTEXT}/${itemCondition}`,
      }),
      ...(hasSeller && {
        seller: {
          '@type': 'AutoDealer',
          name: seller.FantasyName,
          ...(address && {
            address: {
              '@type': 'PostalAddress',
              addressLocality: address.locality,
              addressRegion: address.region,
              addressCountry: 'BR',
            },
          }),
        },
      }),
    },
  }

  return <Jsonld id={schemaTypeId} dataSchema={json} dataQa={schemaTypeId} />
}

ProductSchema.propTypes = {
  ad: PropTypes.shape({
    Specification: PropTypes.shape({
      Title: PropTypes.string,
      Make: PropTypes.shape({ Value: PropTypes.string }),
      Odometer: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    }),
    Prices: PropTypes.shape({
      Price: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    }),
    Seller: PropTypes.shape({
      SellerType: PropTypes.string,
      FantasyName: PropTypes.string,
    }),
    UniqueId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }),
  address: PropTypes.shape({
    locality: PropTypes.string,
    region: PropTypes.string,
  }),
  canonical: PropTypes.string,
  productSchemaData: PropTypes.shape({
    valid: PropTypes.bool,
    price: PropTypes.number,
    image: PropTypes.string,
  }).isRequired,
}

ProductSchema.defaultProps = {
  ad: undefined,
  address: undefined,
  canonical: undefined,
}
